// extracted by mini-css-extract-plugin
module.exports = {"small":"style_small__19t7m","large":"style_large__1CLuz"};